import React from 'react';
import { Box, FormControl, InputLabel, MenuItem, Select } from '@mui/material';

export default function ListSortControls({
  sortField,
  sortDirection,
  onSortFieldChange,
  onSortDirectionChange,
  fieldOptions,
  sx,
}) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: 2,
        alignItems: 'center',
        mb: 2,
        ...sx,
      }}
    >
      <FormControl size="small" sx={{ minWidth: { xs: '100%', sm: 200 } }}>
        <InputLabel id="list-sort-field-label">Sort by</InputLabel>
        <Select
          labelId="list-sort-field-label"
          label="Sort by"
          value={sortField}
          onChange={(e) => onSortFieldChange(e.target.value)}
        >
          {fieldOptions.map((opt) => (
            <MenuItem key={opt.value} value={opt.value}>
              {opt.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl size="small" sx={{ minWidth: { xs: '100%', sm: 160 } }}>
        <InputLabel id="list-sort-direction-label">Order</InputLabel>
        <Select
          labelId="list-sort-direction-label"
          label="Order"
          value={sortDirection}
          onChange={(e) => onSortDirectionChange(e.target.value)}
        >
          <MenuItem value="asc">Ascending</MenuItem>
          <MenuItem value="desc">Descending</MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
}
